import { useGetPurchaseHistoryQuery } from "@/queries/useGetPurchaseHistoryQuery";
import { useEffect, useState } from "react";

export const usePurchaseHistory = () => {
  const { data: purchaseData, isLoading } = useGetPurchaseHistoryQuery();
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (!showMore) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [showMore]);

  return { purchaseData: purchaseData || [], isLoading, showMore, setShowMore };
};
